import { FC } from "react";
import { Box } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface Props {
  isRead: boolean;
}

export const NotificationIndicator: FC<Props> = ({ isRead }) => {
  return (
    <Box
      data-testid={isRead ? undefined : "notification-unread-indicator"}
      sx={{
        width: 10,
        height: 10,
        flexShrink: 0,
        borderRadius: "50%",
        marginTop: "6px",
        backgroundColor: !isRead
          ? nawyTheme.nawy.colors.semantic.layer.accent
          : nawyTheme.nawy.colors.semantic.layer.secondary,
      }}
    />
  );
};
